import { Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import RadioButton from "../../../../common/RadioButton";
import { LinkButton, SecondaryButton } from "../../../../common/Buttons";
import {
  getHealthcareProxy,
  getHealthcareQuestionByCategory,
  postHealthcareProxy,
} from "../../../../services/documentServices";
import { QuestionByCategoryType } from "../../../../constants/constants";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const Residance = ({ next, setButtonDisabled }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [residanceAndHousing, setResidanceAndHousing] = useState([]);

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchResidential() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.RESIDENCE_AND_HOUSING,
      id
    );
    if (result?.success) {
      setResidanceAndHousing(
        {
          title: result?.payLoad[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }
  useEffect(() => {
    fetchData();
    fetchResidential();
  }, []);
  const setYes = (e) => {
    const updateList = {
      ...residanceAndHousing,
      data: residanceAndHousing?.data?.map((ele) => {
        return ele.id == e.id ? { ...ele, yes: true } : ele;
      })
    }
    setResidanceAndHousing(updateList);
  };
  const setNo = (e) => {
    const updateList = {
      ...residanceAndHousing,
      data: residanceAndHousing?.data?.map((ele) => {
        return ele.id == e.id ? { ...ele, yes: false } : ele;
      })
    }
    setResidanceAndHousing(updateList);
  };


  const setAllTrue = (currentObj) =>
    currentObj.subQuestions?.length
      ? currentObj?.subQuestions?.every((item) => item.yes)
      : currentObj.yes;

  const handleSubmit = async () => {
    setButtonDisabled(true);

    const payload = {
      ...data,
      healthProxyAnswers: [
        ...data.healthProxyAnswers,
        ...residanceAndHousing?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),
      ],
      checkListTab3:
        residanceAndHousing?.data.every(setAllTrue)
          ? 2
          : 1,
    };
    const result = await postHealthcareProxy(payload, id);

    if (result?.success) {
      next();
    }
    setButtonDisabled(false);
  };

  return (
    <form
      id="form_submit"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      className="summary-table documents-card-height"
    >
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box component="div" width="60%" className="medical-care-container">

          <Typography variant="p" fontWeight="bold">
            {t(residanceAndHousing?.title?.translationKey)}
          </Typography>
          <Box padding="0 2rem" component="div" className="section-1">
            <Box component="div" className="sub-section-1">
              <Typography variant="p" marginRight="1rem">
                {t("YES")}
              </Typography>
              <Typography variant="p"> {t("NO")}</Typography>
            </Box>
            <ol>
              {residanceAndHousing?.data?.length > 0 && residanceAndHousing?.data?.map((elem, index) => {
                return (
                  <li>
                    <Box component="div" key={index} className="sub-section-2">
                      <Typography variant="p" margin="0 0.5rem" width="80%">
                        {elem?.translationKey ? t(elem.translationKey) : ""}
                      </Typography>
                      <RadioButton
                        value="0"
                        theme="box"
                        paddingLeft="1rem"
                        checked={elem.yes}
                        onChange={() => {
                          setYes(elem);
                        }}
                      />
                      <RadioButton
                        value="1"
                        theme="box"
                        checked={!elem.yes && elem.yes != null}
                        onChange={() => {
                          setNo(elem);
                        }}
                      />
                    </Box>
                  </li>
                );
              })}
            </ol>
          </Box>

        </Box>
      )}
    </form>
  );
};

export default Residance;
